// @flow
import { combineReducers } from 'redux';

import Auth from './auth/reducers';
import Layout from './layout/reducers';
import WorkSession from './workSession/reducers';

export default (combineReducers({
    Auth,
    Layout,
    WorkSession,
}): any);
